module.exports = __webpack_public_path__ + "static/img/env04.69b8137.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env04.png
// module id = 586
// module chunks = 4